export default "__VITE_ASSET__DQvI1kEl__"